// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"524":"app","594":"about"}[chunkId] || chunkId) + "." + {"524":"b789b3d3","594":"d7ea5b2a","655":"78e2397d","656":"05e692d8"}[chunkId] + ".css";
};